<template>
	<div>
		<div class="information-con-left-head">
			<div class="information-myleft">
				<el-upload
					id="upload"
					class="avatar-uploader"
					action="http://www.005.tv/obi_m/api/v1/user/avatar"
					:data="uplaodData"
					:show-file-list="false"
					:on-success="handleAvatarSuccess"
					:before-upload="beforeAvatarUpload"
				>
					<img v-if="imageUrl" :src="imageUrl" class="information-myimg" height="70" width="70" />
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<input class="information-myright-div-input1" disabled="disabled" v-model="nickname" />
				<!-- <div class="sssss-div">
          <label for="upload">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </label>
				</div>-->
			</div>
			<div class="information-myright">
				<div class="information-myright-div">
					<p class="information-myright-div-p">用户UID</p>
					<p class="information-myright-div-p1">{{info.unumber}}</p>
				</div>
				<!-- <div class="information-myright-div1">
          <p class="information-myright-div-p">昵称</p>
          <input class="information-myright-div-input" v-model="nickname" disabled="disabled" />
          <el-button type="text" @click="open('确认修改')" style="text-align:center;">
            <p class="information-myright-div-p2">修改</p>
          </el-button>
				</div>-->
				<div class="information-myright-div1">
					<p class="information-myright-div-p">签名</p>
					<input type="text" class="information-myinput" placeholder="暂无签名" v-model="autograph" />
				</div>
				<div class="information-myright-div1">
					<p class="information-myright-div-p">性别</p>
					<select class="information-myselect" v-model="gender" @change="setgender($event)">
						<option :value="index" v-for="(item, index) in genderlist" :key="index">{{item}}</option>
					</select>
				</div>
				<div class="information-myright-div1">
					<p class="information-myright-div-p">手机</p>
					<p class="information-myright-div-p1">{{mobile}}</p>
					<router-link to="../replace">
						<p class="information-myright-div-p2">修改</p>
					</router-link>
				</div>
				<div class="information-myright-div1">
					<p class="information-myright-div-p">密码</p>
					<p class="information-myright-div-p1">******</p>
					<router-link to="../password">
						<p class="information-myright-div-p2">修改</p>
					</router-link>
				</div>
				<div class="information-mydiv1">
					<button type="button" class="information-mybtn1" @click="setsave">保存</button>
				</div>
			</div>
		</div>
		<div class="information-con-left-foot">
			<div>
				<!-- <p class="information-myp3">账户余额（羁绊币）</p>
				<p class="information-myp4">0</p>
				<p class="information-myp3">合1200元</p>-->
			</div>
			<div>
				<button type="button" class="information-btn">充值</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "App",
		components: {},
		data() {
			return {
				info: "",
				nickname: "",
				autograph: "",
				gender: "0",
				genderlist: { 0: "女", 1: "男" },
				imageUrl: "",
				uplaodData: {
					token: this.$cookies.get("token")
				},
				mobile: ""
			};
		},
		methods: {
			formatPhone(p) {
				if (p) {
					return p.substring(0, 3) + "****" + p.substring(p.length - 4);
				}
			},
			open(a) {
				this.$prompt(a, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消"
				})
					.then(({ value }) => {
						this.nickname = value;
						this.$message({
							type: "success",
							message: "修改成功：" + value
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "取消输入"
						});
					});
			},
			submitUpload() {
				this.$refs.upload.submit();
				console.log(this.$refs.upload);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			flieSuccess(res) {
				console.log(this.$refs.upload);
			},
			setgender(event) {
				this.gender = event.target.value;
			},
			setsave() {
				this.$http
					.post("user/setinfo", {
						token: this.$cookies.get("token"),
						gender: this.gender,
						bio: this.autograph,
						nickname: this.nickname
					})
					.then(res => {
						this.$message({
							showClose: true,
							message: "保存成功",
							type: "success",
							duration: 0
						});
					});
			},
			// 上传
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === "image/jpeg";
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error("上传头像图片只能是 JPG 格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传头像图片大小不能超过 2MB!");
				}
				return isJPG && isLt2M;
			}
		},
		beforeCreate() {
			this.$http
				.post("user/info/", { token: this.$cookies.get("token") })
				.then(res => {
					if (res.body.code == 1) {
						this.info = res.body.data;
						this.mobile = this.formatPhone(res.body.data.mobile);
						this.nickname = res.body.data.nickname;
						this.autograph = res.body.data.bio;
						this.gender = res.body.data.gender;
						this.imageUrl = res.body.data.avatar;
					}
				});
		}
	};
</script>

<style>
	.avatar-uploader-icon {
		background-image: url(../../img/grzx.png);
		width: 70px !important;
		height: 70px !important;
		background-size: 100% 100%;
	}
	.el-icon-plus:before {
		content: "";
	}
	.el-message-box__message p {
		text-align: center;
		font-size: 16px;
		color: #28a3b1;
		margin-bottom: 30px;
	}
	.el-message-box__header {
		display: none;
	}
	.el-message-box {
		padding: 30px 20px;
		width: 286px;
		height: 246px;
		box-sizing: border-box;
		border-radius: 16px;
	}
	.el-input__inner {
		border: 1px solid #808080;
	}
	.el-message-box__btns {
		text-align: center;
	}
	.el-button {
		width: 90px;
		height: 40px;
		font-size: 16px;
		color: #fff;
	}
	.el-button:hover {
		color: #fff;
	}
	.el-message-box__btns button:nth-child(2) {
		border: 0;
		background-color: #404040;
		border-radius: 6px;
	}
	.el-message-box__btns button:nth-child(1) {
		border: 0;
		background-color: #cccccc;
		border-radius: 6px;
	}
	.information-con-left-head {
		width: 900px;
		height: 402px;
		padding: 24px;
		box-sizing: border-box;
		display: flex;
		border: 1px solid #e6e6e6;
		border-radius: 6px;
		background-color: #ffffff;
	}

	.information-myimg {
		width: 70px;
		height: 70px;
		margin: 0 auto;
		border-radius: 50%;
	}

	.information-myp {
		width: 100px;
		font-size: 16px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 10px 0;
		text-align: center;
	}

	.information-mybtn {
		width: 84px;
		height: 36px;
		border: 0;
		border-radius: 4px;
		background-color: #404040;
		color: #fff;
		font-size: 14px;
		margin: 13px auto 0;
	}

	.information-myleft {
		margin-right: 40px;
	}

	.information-myright {
		padding: 10px 0;
	}

	.information-myright-div {
		display: flex;
		align-items: center;
	}

	.information-myright-div1 {
		display: flex;
		align-items: center;
		margin-top: 10px;
	}

	.information-myright-div-p {
		width: 80px;
		height: 40px;
		text-align: right;
		line-height: 40px;
		font-size: 16px;
		margin-right: 16px;
		font-weight: bold;
	}
	.information-myright-div-input1 {
		width: 7em;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: bold;
		background-color: white;
		border: none;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.information-myright-div-input {
		width: fit-content;
		max-width: 140px;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: bold;
		background-color: white;
		border: none;
		text-align: center;
	}
	.information-myright-div-p1 {
		font-size: 14px;
		margin-right: 15px;
	}

	.information-myright-div-p2 {
		font-size: 14px;
		color: #28a3b1;
		text-align: left;
	}

	.information-myinput {
		width: 406px;
		height: 36px;
		padding-left: 10px;
		font-size: 14px;
		border-radius: 4px;
		border: 1px solid #cccccc;
	}

	.information-myselect {
		width: 360px;
		height: 36px;
		border-radius: 4px;
		font-size: 14px;
		padding-left: 10px;
		appearance: none;
		-moz-appearance: none;
		-webkit-appearance: none;
		/* 右侧添加小箭头的背景图 */
		background: url("../../img/select.png") 330px center no-repeat;
		background-size: 16px;
	}

	.information-mybtn1 {
		width: 120px;
		height: 40px;
		background-color: #28a3b1;
		border: 0;
		border-radius: 4px;
		color: #fff;
		font-size: 16px;
		margin: 0 auto;
	}

	.information-mydiv1 {
		display: flex;
		justify-content: center;
		margin-top: 10px;
	}
	.information-con-left-foot {
		width: 900px;
		height: 142px;
		margin-top: 20px;
		background: url(../../img/myimg.png);
		padding: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
	}
	.information-myp3 {
		font-size: 14px;
	}
	.information-myp4 {
		font-size: 36px;
		font-weight: bold;
	}
	.information-btn {
		font-size: 14px;
		font-weight: bold;
		width: 100px;
		height: 36px;
		border-radius: 4px;
		border: 0;
		background-color: #404040;
		color: #fff;
	}
	.sssss-div {
		display: flex;
		justify-content: center;
	}
</style>
<style>
	.el-button--primary /deep/ {
		background-color: black !important;
		border-color: none !important;
	}
	.avatar {
		border-radius: 50%;
	}
	.avatar-uploader {
		width: 112px;
		display: flex;
		justify-content: center;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/information.vue